import ResponsePage from './ResponsePage'

export default {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/project/:projectId/response',
      component: ResponsePage,
    },
  ],
}



// WEBPACK FOOTER //
// ./src/main/content/project/ecommerce/responseMessage/responseConfig.js